"use client"

import Link from 'next/link'
import { useRouter } from 'next/navigation'
import { useState } from 'react'
import { getHeaderAuthActions } from '@/lib/auth-state'
import { createClient } from '@/lib/supabase-browser'
import { useAuthStore } from '@/stores/auth-store'

export function HeaderAuthActions({ mobile = false, onNavigate }: { mobile?: boolean; onNavigate?: () => void }) {
  const router = useRouter()
  const [submitting, setSubmitting] = useState(false)
  const user = useAuthStore((state) => state.user)
  const status = useAuthStore((state) => state.status)
  const clearUser = useAuthStore((state) => state.clearUser)
  const actions = getHeaderAuthActions(status === 'authenticated' ? user : null)

  async function handleLogout() {
    if (submitting) return
    setSubmitting(true)
    clearUser()
    onNavigate?.()
    try {
      await createClient().auth.signOut()
    } finally {
      setSubmitting(false)
      router.refresh()
    }
  }

  if (mobile) {
    return <div className="mt-7 grid gap-2 border-t border-[#3A3A3A] pt-5">
      <p className="text-xs font-black uppercase tracking-[0.2em] text-[#FF4500]">Account</p>
      {actions.map((action) => action.action === 'logout'
        ? <button key={action.label} type="button" onClick={handleLogout} disabled={submitting} className="py-0.5 disabled:opacity-60  text-left text-base font-black leading-7 tracking-[-0.03em] text-[#F3F4F6] transition hover:text-[#FF4500]">{action.label}</button>
        : <Link key={action.label} href={action.href ?? '/admin/login'} onClick={onNavigate} className="py-0.5 text-base font-black leading-7 tracking-[-0.03em] text-[#F3F4F6] transition hover:text-[#FF4500]">{action.label}</Link>)}
    </div>
  }

  return <div className="hidden items-center gap-2 lg:flex">
    {actions.map((action) => action.action === 'logout'
      ? <button key={action.label} type="button" onClick={handleLogout} disabled={submitting} className="rounded-full disabled:opacity-60  border border-[#3A3A3A] bg-[#2A2A2A] px-5 py-3 text-sm font-black text-[#F9FAFB] shadow-lg shadow-[#111827]/5 transition hover:border-[#FF4500] hover:text-[#FF4500]">{action.label}</button>
      : <Link key={action.label} href={action.href ?? '/admin/login'} className={action.label === '관리자 대시보드' ? 'rounded-full bg-[#FF4500] px-5 py-3 text-sm font-black text-white shadow-lg shadow-[#FF4500]/20 transition hover:bg-[#CC3700]' : 'rounded-full border border-[#3A3A3A] bg-[#2A2A2A] px-5 py-3 text-sm font-black text-[#F9FAFB] shadow-lg shadow-[#111827]/5 transition hover:border-[#FF4500] hover:text-[#FF4500]'}>{action.label}</Link>)}
  </div>
}
